const actions = {
  SEARCH_SMS: 'SEARCH_SMS',
  SEARCH_SMS_ENDED: 'SEARCH_SMS_ENDED',
  GET_SMS_VERIFICATION_CODE: 'GET_SMS_VERIFICATION_CODE',
  GET_SMS_VERIFICATION_CODE_ENDED: 'GET_SMS_VERIFICATION_CODE_ENDED',
};

export default actions;
